import TransactionsGrid from "src/components/TransactionsGrid/TransactionsGrid";
import { useDataTableState } from "src/hooks/useDataTableState";
import { Tag } from "src/models/TagModel";
import { useGetTagsQuery } from "src/store/apis/Tags";
import { columns, config } from "./columns";
import CreateModal from "./CreateModal";

export default function TagsPage() {
  const { currentPage, setCurrentPage, setFilters, dataColumns } =
    useDataTableState<Tag>({
      columns,
      config,
    });

  const { data, isLoading, isFetching, refetch } = useGetTagsQuery();

  return (
    <TransactionsGrid
      onFilterChange={setFilters}
      rowKey="id"
      columns={dataColumns}
      dataSource={data?.result?.data ?? []}
      isLoading={isLoading || isFetching}
      refetch={refetch}
      currentPage={currentPage}
      onChangePage={setCurrentPage}
      totalItems={data?.result?.data?.length ?? 0}
      suffixNode={<CreateModal />}
    />
  );
}